var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUnread(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94679 14.8873L3 16.2906L4.40575 13.3353L4.57144 12.987L4.38448 12.6496C3.92496 11.8204 3.66603 10.8993 3.64985 9.96076L3.64959 9.95009C3.61709 8.91751 3.86906 7.89136 4.37413 6.98664C4.88134 6.0781 5.61547 5.32065 6.50847 4.80081L6.51105 4.7993C7.39909 4.27761 8.41862 4 9.45441 4H9.45545H9.45645H9.45746H9.45847H9.4595H9.4605H9.46153H9.46255H9.46356H9.46456H9.46558H9.4666H9.46763H9.46864H9.46964H9.47068H9.47168H9.47271C10.3588 4 11.2584 4.21199 12.0596 4.60438C12.8663 5.00414 13.5748 5.59138 14.1108 6.30643C14.6512 7.02739 15.0261 7.86944 15.1886 8.74702C15.3519 9.62945 15.3108 10.5537 15.0663 11.4182C14.8226 12.2797 14.3746 13.0804 13.7689 13.7525C13.167 14.4111 12.399 14.9348 11.5659 15.2619C10.7287 15.587 9.82387 15.7099 8.92424 15.6281C8.12662 15.5548 7.33737 15.3101 6.64068 14.9129L6.30042 14.7189L5.94679 14.8873Z",
    strokeWidth: 1.5,
    stroke: "#5E5E66"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0366 7.25C17.0366 5.59315 15.6935 4.25 14.0366 4.25C12.3798 4.25 11.0366 5.59315 11.0366 7.25C11.0366 8.90685 12.3798 10.25 14.0366 10.25C15.6935 10.25 17.0366 8.90685 17.0366 7.25Z",
    fill: "#FE50CE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnread);
export default __webpack_public_path__ + "static/media/unread.29958f94.svg";
export { ForwardRef as ReactComponent };